import { useState, useEffect } from "react";

const SUPABASE_URL = "https://opmezbwytaawtqusritn.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9wbWV6Ynd5dGFhd3RxdXNyaXRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2NTAzMzQsImV4cCI6MjA5MzIyNjMzNH0.-62p13gynVH_URHGm9A38Vb7Dnh0TfFr1bx9m83bXDI";
const ADMIN_PASSWORD = "echo2026";

const headers = {
  "apikey": SUPABASE_KEY,
  "Authorization": `Bearer ${SUPABASE_KEY}`
};

async function fetchTable(table, query = "") {
  try {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}${query}`, { headers });
    if (!res.ok) return [];
    return await res.json();
  } catch { return []; }
}

function StatCard({ emoji, value, label, sub, color }) {
  return (
    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(200,184,162,0.1)", borderRadius: "16px", padding: "24px 20px", flex: 1, minWidth: "140px" }}>
      <div style={{ fontSize: "24px", marginBottom: "8px" }}>{emoji}</div>
      <div style={{ fontSize: "32px", fontWeight: "700", color: color || "#c8b8a2", marginBottom: "4px", fontFamily: "Georgia, serif" }}>{value}</div>
      <div style={{ fontSize: "13px", color: "#c8b8a2", marginBottom: "2px", fontFamily: "Georgia, serif" }}>{label}</div>
      {sub && <div style={{ fontSize: "11px", color: "rgba(200,184,162,0.4)", fontFamily: "Georgia, serif" }}>{sub}</div>}
    </div>
  );
}

function BarChart({ data, title }) {
  const max = Math.max(...data.map(d => d.value), 1);
  return (
    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(200,184,162,0.1)", borderRadius: "16px", padding: "24px" }}>
      <div style={{ fontSize: "13px", letterSpacing: "0.15em", color: "rgba(200,184,162,0.5)", marginBottom: "20px", fontFamily: "Georgia, serif" }}>{title}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {data.map((d, i) => (
          <div key={i}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
              <span style={{ fontSize: "13px", color: "#c8b8a2", fontFamily: "Georgia, serif" }}>{d.label}</span>
              <span style={{ fontSize: "13px", color: "rgba(200,184,162,0.6)", fontFamily: "Georgia, serif" }}>{d.value}</span>
            </div>
            <div style={{ height: "6px", background: "rgba(200,184,162,0.08)", borderRadius: "3px", overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${(d.value / max) * 100}%`, background: d.color || "rgba(200,184,162,0.5)", borderRadius: "3px", transition: "width 1s ease" }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function LoginScreen({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 150); }, []);

  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) {
      onLogin();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#08080e", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 24px", fontFamily: "Georgia, serif" }}>
      <div style={{ maxWidth: "320px", width: "100%", textAlign: "center", opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(16px)", transition: "all 0.8s ease" }}>
        <div style={{ fontSize: "11px", letterSpacing: "0.4em", color: "rgba(200,184,162,0.3)", marginBottom: "16px" }}>ECHO</div>
        <h2 style={{ fontSize: "24px", fontWeight: "400", color: "#e8e4dc", margin: "0 0 8px" }}>Analytics</h2>
        <p style={{ fontSize: "14px", color: "rgba(200,184,162,0.4)", margin: "0 0 40px", lineHeight: "1.6" }}>Private dashboard. Founders only.</p>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleLogin()}
          placeholder="Password"
          autoFocus
          style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: `1px solid ${error ? "rgba(255,100,100,0.4)" : "rgba(200,184,162,0.15)"}`, borderRadius: "12px", padding: "14px 16px", color: "#e8e4dc", fontSize: "15px", fontFamily: "Georgia, serif", outline: "none", boxSizing: "border-box", marginBottom: "12px", textAlign: "center", letterSpacing: "0.1em" }}
        />
        {error && <div style={{ fontSize: "13px", color: "rgba(255,100,100,0.7)", marginBottom: "12px" }}>Incorrect password</div>}
        <button onClick={handleLogin} style={{ width: "100%", padding: "14px", background: "rgba(200,184,162,0.88)", border: "none", borderRadius: "50px", color: "#08080e", fontSize: "15px", fontFamily: "Georgia, serif", fontWeight: "700", cursor: "pointer" }}>
          Enter
        </button>
      </div>
    </div>
  );
}

export default function Analytics() {
  const [authed, setAuthed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [lastRefresh, setLastRefresh] = useState(null);

  const loadData = async () => {
    setLoading(true);
    try {
      const [profiles, nuggets, checkins, exitNotes] = await Promise.all([
        fetchTable("profiles"),
        fetchTable("nuggets", "?order=created_at.desc"),
        fetchTable("checkins", "?order=created_at.desc"),
        fetchTable("exit_notes", "?order=created_at.desc"),
      ]);

      // Time calculations
      const now = Date.now();
      const day = 24 * 60 * 60 * 1000;
      const week = 7 * day;

      const thisWeek = (arr, field = "created_at") => arr.filter(r => new Date(r[field]).getTime() > now - week);
      const today = (arr, field = "created_at") => arr.filter(r => new Date(r[field]).getTime() > now - day);

      // Retention — users who came back within 7 days
      const returningUsers = profiles.filter(p => p.conversation_count > 1).length;
      const retentionRate = profiles.length > 0 ? Math.round((returningUsers / profiles.length) * 100) : 0;

      // Check-in distribution
      const heavy = checkins.filter(c => c.state === "heavy").length;
      const okay = checkins.filter(c => c.state === "okay").length;
      const good = checkins.filter(c => c.state === "good").length;

      // Nugget categories
      const categories = ["direction", "money", "relationships", "mind", "brotherhood"];
      const catLabels = { direction: "💼 Life & Direction", money: "💰 Money & Stability", relationships: "❤️ Relationships", mind: "🧠 Mind & Self", brotherhood: "🤝 Brotherhood" };
      const nuggetsByCategory = categories.map(cat => ({
        label: catLabels[cat],
        value: nuggets.filter(n => n.category === cat).length,
        color: "rgba(200,184,162,0.5)"
      }));

      // Average conversations per user
      const avgConversations = profiles.length > 0
        ? (profiles.reduce((sum, p) => sum + (p.conversation_count || 0), 0) / profiles.length).toFixed(1)
        : 0;

      // Exit note completion
      const totalConversations = profiles.reduce((sum, p) => sum + (p.conversation_count || 0), 0);
      const exitNoteRate = totalConversations > 0 ? Math.round((exitNotes.length / totalConversations) * 100) : 0;

      setData({
        totalUsers: profiles.length,
        newThisWeek: thisWeek(profiles, "created_at").length,
        newToday: today(profiles, "created_at").length,
        returningUsers,
        retentionRate,
        totalNuggets: nuggets.length,
        nuggetsThisWeek: thisWeek(nuggets).length,
        nuggetsByCategory,
        totalCheckins: checkins.length,
        checkinsThisWeek: thisWeek(checkins).length,
        heavy, okay, good,
        totalExitNotes: exitNotes.length,
        exitNoteRate,
        avgConversations,
        totalConversations,
        recentNuggets: nuggets.slice(0, 5),
        recentCheckins: checkins.slice(0, 5),
      });
      setLastRefresh(new Date().toLocaleTimeString());
    } catch (e) {
      console.error("Analytics load error:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authed) loadData();
  }, [authed]);

  if (!authed) return <LoginScreen onLogin={() => setAuthed(true)} />;

  return (
    <div style={{ minHeight: "100vh", background: "#08080e", fontFamily: "Georgia, serif", color: "#e8e4dc" }}>
      {/* Header */}
      <div style={{ padding: "20px 24px", borderBottom: "1px solid rgba(255,255,255,0.05)", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, background: "rgba(8,8,14,0.96)", backdropFilter: "blur(12px)", zIndex: 10 }}>
        <div>
          <div style={{ fontSize: "11px", letterSpacing: "0.4em", color: "rgba(200,184,162,0.35)" }}>ECHO</div>
          <div style={{ fontSize: "18px", fontWeight: "400", color: "#e8e4dc", marginTop: "2px" }}>Analytics Dashboard</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {lastRefresh && <div style={{ fontSize: "11px", color: "rgba(200,184,162,0.3)" }}>Updated {lastRefresh}</div>}
          <button onClick={loadData} disabled={loading}
            style={{ background: "rgba(200,184,162,0.1)", border: "1px solid rgba(200,184,162,0.2)", borderRadius: "20px", padding: "8px 16px", color: "rgba(200,184,162,0.6)", fontSize: "12px", cursor: loading ? "default" : "pointer", fontFamily: "Georgia, serif" }}>
            {loading ? "Loading..." : "↺ Refresh"}
          </button>
        </div>
      </div>

      {loading && !data && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh" }}>
          <div style={{ fontSize: "14px", color: "rgba(200,184,162,0.4)" }}>Loading data...</div>
        </div>
      )}

      {data && (
        <div style={{ padding: "32px 24px", maxWidth: "900px", margin: "0 auto" }}>

          {/* Section: Users */}
          <div style={{ fontSize: "11px", letterSpacing: "0.3em", color: "rgba(200,184,162,0.35)", marginBottom: "16px" }}>USERS</div>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "32px" }}>
            <StatCard emoji="👤" value={data.totalUsers} label="Total users" sub={`+${data.newThisWeek} this week · +${data.newToday} today`} />
            <StatCard emoji="🔄" value={`${data.retentionRate}%`} label="Return rate" sub={`${data.returningUsers} of ${data.totalUsers} came back`} color={data.retentionRate >= 30 ? "#4ade80" : data.retentionRate >= 15 ? "#facc15" : "#f87171"} />
            <StatCard emoji="💬" value={data.avgConversations} label="Avg conversations" sub={`${data.totalConversations} total`} />
          </div>

          {/* Section: Check-ins */}
          <div style={{ fontSize: "11px", letterSpacing: "0.3em", color: "rgba(200,184,162,0.35)", marginBottom: "16px" }}>CHECK-INS</div>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "12px" }}>
            <StatCard emoji="⛈️" value={data.heavy} label="Heavy" sub="arrived struggling" color="#f87171" />
            <StatCard emoji="⛅" value={data.okay} label="Okay" sub="somewhere in between" color="#facc15" />
            <StatCard emoji="☀️" value={data.good} label="Good" sub="arrived well" color="#4ade80" />
          </div>
          <div style={{ marginBottom: "32px" }}>
            <BarChart title="CHECK-IN DISTRIBUTION" data={[
              { label: "Heavy", value: data.heavy, color: "rgba(248,113,113,0.5)" },
              { label: "Okay", value: data.okay, color: "rgba(250,204,21,0.5)" },
              { label: "Good", value: data.good, color: "rgba(74,222,128,0.5)" },
            ]} />
          </div>

          {/* Section: Nuggets */}
          <div style={{ fontSize: "11px", letterSpacing: "0.3em", color: "rgba(200,184,162,0.35)", marginBottom: "16px" }}>NUGGETS & REFLECTION</div>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "12px" }}>
            <StatCard emoji="💎" value={data.totalNuggets} label="Nuggets saved" sub={`+${data.nuggetsThisWeek} this week`} />
            <StatCard emoji="🪞" value={data.totalExitNotes} label="Exit notes written" sub={`${data.exitNoteRate}% completion rate`} color={data.exitNoteRate >= 40 ? "#4ade80" : data.exitNoteRate >= 20 ? "#facc15" : "#c8b8a2"} />
          </div>
          <div style={{ marginBottom: "32px" }}>
            <BarChart title="NUGGETS BY CIRCLE" data={data.nuggetsByCategory} />
          </div>

          {/* Recent nuggets */}
          {data.recentNuggets.length > 0 && (
            <div style={{ marginBottom: "32px" }}>
              <div style={{ fontSize: "11px", letterSpacing: "0.3em", color: "rgba(200,184,162,0.35)", marginBottom: "16px" }}>RECENT NUGGETS</div>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {data.recentNuggets.map((n, i) => (
                  <div key={i} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(200,184,162,0.08)", borderRadius: "12px", padding: "16px" }}>
                    <div style={{ fontSize: "14px", color: "#c8b8a2", fontStyle: "italic", lineHeight: "1.6", marginBottom: "8px" }}>"{n.text.length > 120 ? n.text.slice(0, 120) + "…" : n.text}"</div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ fontSize: "11px", color: "rgba(200,184,162,0.35)" }}>{n.category}</span>
                      <span style={{ fontSize: "11px", color: "rgba(200,184,162,0.35)" }}>{new Date(n.created_at).toLocaleDateString("en-GB")}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Recent check-ins */}
          {data.recentCheckins.length > 0 && (
            <div style={{ marginBottom: "32px" }}>
              <div style={{ fontSize: "11px", letterSpacing: "0.3em", color: "rgba(200,184,162,0.35)", marginBottom: "16px" }}>RECENT CHECK-INS</div>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {data.recentCheckins.map((c, i) => (
                  <div key={i} style={{ background: c.state === "heavy" ? "rgba(248,113,113,0.1)" : c.state === "good" ? "rgba(74,222,128,0.1)" : "rgba(250,204,21,0.1)", border: `1px solid ${c.state === "heavy" ? "rgba(248,113,113,0.2)" : c.state === "good" ? "rgba(74,222,128,0.2)" : "rgba(250,204,21,0.2)"}`, borderRadius: "20px", padding: "6px 14px", fontSize: "12px", color: "rgba(200,184,162,0.7)" }}>
                    {c.state === "heavy" ? "⛈️" : c.state === "good" ? "☀️" : "⛅"} {c.state} · {new Date(c.created_at).toLocaleDateString("en-GB")}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Footer */}
          <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: "24px", textAlign: "center" }}>
            <div style={{ fontSize: "12px", color: "rgba(200,184,162,0.25)", lineHeight: "1.8" }}>
              Echo Analytics · Private · Founders only<br />
              Data from Supabase · Updates on refresh
            </div>
          </div>

        </div>
      )}

      <style>{`* { box-sizing: border-box; } ::-webkit-scrollbar { width: 4px; } ::-webkit-scrollbar-track { background: transparent; } ::-webkit-scrollbar-thumb { background: rgba(200,184,162,0.2); border-radius: 2px; }`}</style>
    </div>
  );
}
